import { BACKEND_URL_V1, deletee } from "lib/Api";
import { FMSError } from "types/Error";
import { StockType } from "types/StockType";

export const deleteStock = async (
  stockId: string,
  type: StockType
): Promise<FMSError | null> => {
  try {
    const response = await deletee(
      `${BACKEND_URL_V1}/stocks/${stockId}/type/${type}`
    );
    if (Math.floor(response.status / 100) === 2) {
      return null;
    }
  } catch (err) {
    return new FMSError("Something went wrong");
  }
  return new FMSError("Something went wrong");
};
